import { ErrorInfo, FC, ReactNode } from 'react'

import { CatchBoundary } from '@tanstack/react-router'

import { error as logError } from '@/utils/logger'

type DashboardBoundaryProps = {
  // Rendered in place of the children once they threw; `reset` mounts the children again.
  fallback: (reset: () => void) => ReactNode
  children: ReactNode
}

const logRenderError = (error: Error, info: ErrorInfo) =>
  logError('dashboard: a widget failed to render', { error, componentStack: info.componentStack })

// Keeps a render error inside the boundary instead of letting it reach the route error component,
// which would replace the whole page.
export const DashboardBoundary: FC<DashboardBoundaryProps> = ({ fallback, children }) => (
  <CatchBoundary
    getResetKey={() => 'dashboard'}
    errorComponent={({ reset }) => fallback(reset)}
    onCatch={logRenderError}
  >
    {children}
  </CatchBoundary>
)
